import { getPlaceholderImage } from "../GetItem/data/photo-data"
import { Image } from "./Image"

/**
 * A listing photo, or the listing's placeholder when it has none.
 *
 * `placeholderSeed` (the listing or brand id) picks the placeholder
 * deterministically so the server and client renders agree. `data-photo`
 * tells the rendered-DOM contract test which one it is looking at.
 */
export const SafeImage = ({
    images = [],
    alt = "",
    eager = false,
    placeholderSeed = 0,
    ...props
}) => {
    const realSrc = images.length > 0 ? images[0] : null

    return (
        <Image
            src={realSrc}
            alt={alt}
            className="relative z-0 w-full h-auto"
            width={576}
            height={324}
            eager={eager}
            priority={eager ? "high" : undefined}
            data-photo={realSrc ? "listing" : "placeholder"}
            // Error/no-photo fallback only. Image renders the real src straight
            // away, so this no longer appears in the server-rendered HTML.
            // Deliberately no onError here: Image already swaps to this exact
            // fallbackSrc and clears srcset, and an extra handler picking another
            // random placeholder would fire a second, pointless request.
            fallbackSrc={getPlaceholderImage(placeholderSeed)}
            {...props}
        />
    )
}
